import { buildForkedSessionAgentPrompt } from './build-forked-session-agent-prompt.js';
import { fetchCloudSessionMeta } from '../../mcp/tools/session-history/fetch-parent-session-cloud.js';

/** Enrich the user prompt for forked sessions before sending to the local agent (UI keeps the original). */
export async function enrichForkedSessionPromptForAgent(params: {
  sessionId: string;
  promptText: string;
  cloudApiBaseUrl: string;
  getCloudAccessToken: () => string;
}): Promise<string> {
  const meta = await fetchCloudSessionMeta({
    sessionId: params.sessionId,
    cloudApiBaseUrl: params.cloudApiBaseUrl,
    getCloudAccessToken: params.getCloudAccessToken,
  });
  if (!meta.ok) return params.promptText;
  const parentSessionId = meta.data.parentSessionId?.trim() ?? '';
  if (!parentSessionId) return params.promptText;
  return buildForkedSessionAgentPrompt(params.promptText, params.sessionId, parentSessionId);
}
